import { io } from "socket.io-client";
import consts from "../constant";

export const socket = io(consts.socketUrl, {
    transports: ['websocket', 'polling'],
    withCredentials: false,
    autoConnect: false,
});
